import { ObjectValues } from 'types';

export type ListenEvents = ObjectValues<typeof LISTEN_EVENTS>;
export const LISTEN_EVENTS = {
  NOTIFICATION_CREATED: 'notification-created',
  MESSAGE_CREATED: 'message-created',
  MESSAGE_DELETED: 'message-deleted',
  MESSAGE_SEEN: 'message-seen',
  LEADS_STATE_CHANGED: 'leads-state-changed',
  LISTING_PAID: 'listing-paid',
  NODE_PROCESSED_SUCCESSFULLY: 'processed-successfully',
  DATA_ROOM_INDEX_UPDATED: 'data-room-index-updated',
  DOWNLOAD_SUCCESSFULLY: 'downloaded-successfully',
  DOWNLOAD_FAILED: 'downloaded-failed',
  DATA_ROOM_ARCHIVE_UPDATED: 'data-room-archive-updated',
  NDA_STATUS_UPDATE: 'nda-status-update',
  NEW_FILES: 'new-accessable-files',
  FILE_CONVERSION_FAILED: 'file-conversion-failed',
  DATA_ROOM_MEMBERS_UPDATED: 'data-room-members-updated',
  NEW_MESSAGE_FILES: 'chat-files-uploaded',
  WAITING_ROOM_UPDATED: 'waiting-room-updated',
  NDAS_UPDATED: 'data-room-ndas-updated',
  RFIS_UPDATED: 'data-room-rfis-updated',
  DR_BULK_CREATED: 'data-rooms-bulk-created',
  DATA_ROOM_STORAGE_CHANGED: 'data-room-storage-changed',
  SECURE_LINK_NDA_STATUS_UPDATED: 'secure-link-nda-status-updated',
  REPORT_PDF_EXPORT_COMPLETED: 'report-pdf-export-completed',
  REPORT_PDF_EXPORT_FAILED: 'report-pdf-export-failed',
  REPORT_CSV_EXPORT_COMPLETED: 'report-csv-export-completed',
  REPORT_CSV_EXPORT_FAILED: 'report-csv-export-failed',
  ANALYTICS_EXPORT_COMPLETED: 'analytics-export-completed',
  ANALYTICS_EXPORT_FAILED: 'analytics-export-failed',
  LEAD_ANALYTICS_EXPORT_COMPLETED: 'buyers-activity-export-completed',
  LEAD_ANALYTICS_EXPORT_FAILED: 'buyers-activity-export-failed',
  DATA_ROOM_PROGRESSION: 'data-room-progression',
  BOSS_MODE_EXPORT_COMPLETED: 'boss-mode-export-completed',
  BOSS_MODE_EXPORT_FAILED: 'boss-mode-export-failed',
  RFI_CATEGORIES_EXPORT_COMPLETED: 'rfi-categories-export-completed',
  RFI_CATEGORIES_EXPORT_FAILED: 'rfi-categories-export-failed',
  ENTERPRISE_USAGE_REPORT_EXPORT_COMPLETED: 'enterprise-usage-report-completed',
  ENTERPRISE_USAGE_REPORT_EXPORT_FAILED: 'enterprise-usage-report-failed',
  IM_EXTRACTION_STARTED: 'im-extraction-started',
  IM_EXTRACTION_COMPLETED: 'im-extraction-completed',
  IM_EXTRACTION_FAILED: 'im-extraction-failed',
  REPLY_SUGGESTIONS_UPDATED: 'reply-suggestions-updated',
  SELLER_CONNECT_IM_UPDATED: 'seller-connect-im-updated',
};
